export function loadingImageList() {
    return [];
}

export function commonImagesList() {
    return [];
}

export function preloadImages(list) {
    list.forEach((src) => {
        const img = new Image();
        img.src = src;
    });
}
